import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

import { StyledBox } from './BaseDialog.styled';

export type BaseDialogProps = {
  title: React.ReactNode;
  message: React.ReactNode;
  onClose: () => void;
  leftActionsSlot?: JSX.Element | false | (JSX.Element | false)[];
  rightActionsSlot?: JSX.Element | false | (JSX.Element | false)[];
} & Omit<DialogProps, 'title'>;

export const BaseDialog = ({
  leftActionsSlot,
  rightActionsSlot,
  open,
  onClose,
  message,
  title,
  ...restProps
}: BaseDialogProps) => {
  return (
    <Dialog onClose={onClose} open={open} {...restProps}>
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={title}
          titleSize="smallBold"
        />
        <CardContent>
          <Typography variant="body1">{message}</Typography>
        </CardContent>
        <CardActionsButtons leftActionsSlot={leftActionsSlot} rightActionsSlot={rightActionsSlot} />
      </StyledBox>
    </Dialog>
  );
};
